import styled from 'styled-components/macro';

const ColumnHeader = styled.th`
  padding: ${({ theme }): string =>
    `${theme.spacing.small} ${theme.spacing.xsmall} ${theme.spacing.xsmall}`};
  text-align: right;
  vertical-align: bottom;
  line-height: 0.7;

  &,
  button {
    vertical-align: bottom;
  }

  button {
    width: 100%;
  }

  &:first-of-type {
    text-align: left;
    margin-left: 0;
    padding-left: 0;

    > span,
    button > span {
      justify-content: flex-start;
    }

    button {
      padding-left: 0;
      margin-left: 0;
      text-align: left;
    }
  }
  &:last-of-type {
    padding-right: 0;
  }
`;

export default ColumnHeader;
